module.exports = __webpack_public_path__ + "static/media/logo-ifp.0f82ce40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/logo-ifp.svg
// module id = 1904
// module chunks = 0